module.exports = __webpack_public_path__ + "img/video-title-en.2ebb00b7.png";